import React from 'react';
import './travel.css';

import travelPic from "../../../assets/images/Loc.jpg"

const TravelInformation = () => {
    return (
        <div className="travel-info">
            <h2>Accomodation</h2>
            <p>
                For Accomodation, you may send an email to {' '}
                <a href="mailto:conference.accomodation@smdc.edu.pk">conference.accomodation@smdc.edu.pk</a>
            </p>
            <h2>Travel Information</h2>
            <p>
                For Traveling Information, you may send an email to{' '}
                <a href="mailto:conference.travel@smdc.edu.pk">conference.travel@smdc.edu.pk</a>
            </p>
            <hr />
            <div className="image-container">
                <img src={travelPic} alt="Travel Information" />
            </div>
        </div>
    );
};

export default TravelInformation;
